import script from "./NavView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavView.vue?vue&type=script&setup=true&lang=js"

import "./NavView.vue?vue&type=style&index=0&id=7f70006c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f70006c"]])

export default __exports__